import script from "./AIAssistantStart.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantStart.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantStart.vue?vue&type=style&index=0&id=768ef5d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768ef5d6"]])

export default __exports__